<template>
  <div id="Headings">
    <div class="title white_color" v-if="className==='white_color'">
      <p>{{data}}</p>
    </div>
    <div class="title blue_color" v-else>
      <p>{{data}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Headings",
  props: ["data", "className"]
};
</script>

<style scoped>
p{
  margin-bottom:0;
}
.blue_color {
  color: var(--mainBlueColor);
}
.white_color {
  color: var(--mainWhiteColor);
}
.content {
  color: var(--mainBlueColor);
  font-size: 40px;
  font-weight: bold;
  text-align: left;
}
.title {
  font-size: 2.5rem;
  font-weight: bold;
  text-align: left;
}

/* Media Queries */
/* Tablet View */
@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
  .title {
    font-size: 2rem;
    text-align: center;
    font-weight: bold;
    justify-content: center;
  }
  h1 {
    font-size: 2.05rem;
  }
}
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .title {
    font-size: 2rem;
    text-align: center;
    font-weight: bold;
    justify-content: center;
  }
  h1 {
    font-size: 2.05rem;
  }
}
/* Mobile View */
@media (min-width: 481px) and (max-width: 767px) {
  .title {
    text-align: center;
    font-weight: bold;
    justify-content: center;
    font-size: 1.5rem;
  }
}
@media (max-width: 480px) {
  .title {
    font-size: 1.5rem;
    text-align: center;
    font-weight: bold;
    justify-content: center;
  }
  h1 {
    font-size: 1.8rem;
  }
}
</style>
